import { render, staticRenderFns } from "./OrderitemSelector.vue?vue&type=template&id=67db0114&scoped=true&"
import script from "./OrderitemSelector.vue?vue&type=script&lang=js&"
export * from "./OrderitemSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67db0114",
  null
  
)

export default component.exports